<template>
  <CRow>
    <CCol col="12" xl="8">
      <CCard no-header>
        <CCardHeader>
          <strong>Πελάτης τιμολογίου:</strong> {{ title }}
        </CCardHeader>
        <CCardBody>
          <CForm>
            <template slot="header">
              Edit Invoice Client id:  {{ $route.params.id }}
            </template>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
              <CInput horizontal type="text" label="Κωδικός*" id="client_code" placeholder="Κωδικός" v-model="client_code">
              <template #append>
                <CButton color="primary" class="zIndex0" @click="generatePassword()">Ανανέωση</CButton>
              </template>
              </CInput>
              <CInput horizontal type="text" label="Επωνυμία Εταιρίας" id="company" placeholder="Επωνυμία Εταιρίας" v-model="company"></CInput>
              <CInput label="Υπεύθυνος Επικοινωνίας*" type="text" id="name" placeholder="Υπεύθυνος Επικοινωνίας" v-model="name" horizontal></CInput>
              <CInput horizontal type="text" label="Διεύθυνση" id="address" placeholder="Διεύθυνση" v-model="address"></CInput>
              <CInput horizontal type="text" label="Πόλη" id="town" placeholder="Πόλη" v-model="town"></CInput>
              <CInput horizontal type="text" label="Νομός" id="state" placeholder="Νομός" v-model="state"></CInput>
              <CInput horizontal type="text" label="Ταχυδρομικός Κώδικας" id="postcode" placeholder="Ταχυδρομικός Κώδικας" v-model="postcode"></CInput>
              <CInput horizontal type="text" label="Τηλέφωνο" id="phone_number_1" placeholder="Τηλέφωνο" v-model="phone_number_1"></CInput>
              <CInput horizontal type="text" label="ΑΦΜ*" id="afm" placeholder="ΑΦΜ" v-model="afm"></CInput>
              <CInput horizontal type="text" label="ΔΟΥ" id="doy" placeholder="ΔΟΥ" v-model="doy"></CInput>
              
              <CButton color="primary" @click="update()">Αποθήκευση</CButton>
              <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'EditInvoiceClient',
  props: {
    caption: {
      type: String,
      default: 'Invoice Client id'
    },
  },
  data: () => {
    return {
        title: '',
        client_code: '',
        name: '',
        afm: '',
        doy: '',
        address: '',
        town: '',
        state: '',
        postcode: '',
        phone_number_1: '',
        company: '',
        showMessage: false,
        alertIsShown: false,
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false
    }
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    generatePassword() {
      const characters ='abcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for ( let i = 0; i < 7; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      this.client_code = 'ΠΕΛ'+result;
    },
    update() {
        let self = this;
        axios.post('/api/invoiceclients/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            client_code: self.client_code,
            name: self.name,
            afm: self.afm,
            doy: self.doy,
            address: self.address,
            town: self.town,
            state: self.state,
            postcode: self.postcode,
            phone_number_1: self.phone_number_1,
            company: self.company,
        })
        .then(function (response) {
            self.message = 'Επιτυχής επεξεργασία πελάτη.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              console.log(error.response.data.message);
              console.log(error);
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function(){
    let self = this;
    axios.get('/api/invoiceclients/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
        self.client_code = response.data.invoiceclient.client_code;
        self.name = response.data.invoiceclient.name;
        self.afm = response.data.invoiceclient.afm;
        self.doy = response.data.invoiceclient.doy;
        self.address = response.data.invoiceclient.address;
        self.town = response.data.invoiceclient.town;
        self.state = response.data.invoiceclient.state;
        self.postcode = response.data.invoiceclient.postcode;
        self.phone_number_1 = response.data.invoiceclient.phone_number_1;
        self.company = response.data.invoiceclient.company;

        const ser_items = Object.entries(response.data.invoiceclient).map(([key, value]) => {return {key: key, value: value}});
        const keys = ["client_code", "name", "address", "phone_number_1", "company", "afm", "doy", "town", "state", "postcode"];
        self.items = ser_items.filter((t) => keys.includes(t.key));
        self.title = self.items.find((t) => t.key == "name").value;
    }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
    });
  }
}
</script>
